<template>
  <div class="reports-add-jobs" :class="{'disable-report': approve}">
    <el-button size="small" class="add" type="primary" @click="open" style="width: 100%">
      + Выбрать {{ tr[type || $route.params.type] }}
    </el-button>

    <el-dialog
      append-to-body
      :title="isCreateJob ? `Создать ${tr[type || $route.params.type]}` : `Выбрать ${tr[type || $route.params.type]}`"
      :visible="dialogObject"
      @close="close"
      custom-class="add-jobs-dialog"
    >
      <div :class="{'disable-report': approve}">
        <div v-if="isCreateJob" class="jobs-create-container">
          <JobsCreate
            :type_prop="type"
            v-if="(type || $route.params.type) !== 'MATERIALS'"
            :obj="obj && obj.id"
            @close="isCreateJob = false"
            @created="fetchJobs"
            isNested
          />
          <MaterialsCreate
            v-else
            :obj="obj && obj.id"
            @close="isCreateJob = false"
            @created="fetchJobs"
            isNested
          />
        </div>
        <div class="add-jobs" v-else-if="!form.job && !isCreateCustom">
          <el-input placeholder="Поиск ..." v-model="search" class="input-search">
            <el-button slot="append" icon="el-icon-search"></el-button>
          </el-input>
          <div class="jobs-ul">
            <div
              class="jobs-li" style="display: flex; justify-content: space-between; flex-wrap: nowrap; width: 100%"
              v-for="(job, index) in filteredList"
              :key="index" @click="selectJob(job)"
            >
              <span>{{ job.name }}</span>
              <strong style="margin-right: 8px; margin-left: 4px;     white-space: nowrap;"
                      v-if="job.type === 'JOB' && Number(job.plan)"
                      :style="{color: pStatus(findPercentage(job.totalValue || 0, job.plan))}">
                {{ findPercentage(job.totalValue || 0, job.plan) }}%
              </strong>
            </div>
            <div class="jobs-li link" v-if="(type || $route.params.type) === 'JOB'">
            <span @click="createCustom">
                  + Добавить произвольную работу
              </span>
            </div>
            <div class="jobs-li link" v-if="role === 'admin'">
            <span @click="createJob">
              + Создать {{ tr[type || $route.params.type] }} в плане
            </span>
            </div>
          </div>
        </div>
        <div class="add-jobs" v-else>
          <div class="select-value" v-if="isCreateCustom" style="width: 100%">
            <el-row>
              <el-col :span="18">
                <el-form-item>
                  <el-input style="margin-right: 8px" v-model="form.job.name" placeholder="Найменование работы">
                  </el-input>
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item>
                  <el-input style="margin-left: 8px" v-model="form.job.unit" placeholder="Ед. изм."/>
                </el-form-item>
              </el-col>
            </el-row>
          </div>
          <div class="select-value"
               v-if="(!$store.state.project.daily_plan || (type || $route.params.type) === 'MATERIALS') && !$store.state.project.plan">
          <span style="margin-right: 20px" v-if="form.job.name && !isCreateCustom">{{
              tra[type || $route.params.type]
            }}: <strong>{{
                form.job.name
              }}</strong>
            {{ form.job.is_unit_value ? ', ' + (form.job.unit && form.job.unit.label || form.job.unit) : '' }}
          </span>
            <div
              v-if="((type || $route.params.type) === 'JOB') && !isCreateCustom"
              style="display: flex; justify-content: flex-end; flex: 1; width: 100%; position: absolute; z-index: 999999; margin-left: -40px; margin-top: 2px">
              <i class="fa fa-edit" style="cursor: pointer" @click="editJob"></i>
            </div>
            <div v-if="(type || $route.params.type) !== 'TECH' && (type || $route.params.type) !== 'PROF'">

              <el-input :placeholder="isCreateCustom ? 'Факт' : 'Значение'"
                        @input="valueMaterials"
                        :value="form.value" class="input-with-select">
                <template
                  v-if="!isCreateCustom"
                  slot="append">{{ form.job.is_unit_value ? 'шт' : form.job.unit }}
                </template>
              </el-input>

              <el-input v-if="(type || $route.params.type) === 'MATERIALS' && form.job.is_unit_value"
                        placeholder="Объем"
                        type="number"
                        v-model="total" class="input-with-select">
                <template slot="append">Объем</template>
              </el-input>
              <el-input
                style="margin-top: 10px; width: calc(100%)"
                placeholder="Комментарий"
                type="textarea"
                v-model="form.comment"
              >
              </el-input>
              <div style="margin-top: 10px">
              <span v-if="form.job.is_unit_value">Объем на 1 eд:
                <strong>{{ form.job.unit_value }} {{ form.job.unit && form.job.unit.label || form.job.unit }}</strong>
              </span>
              </div>
            </div>
            <div v-else style="display: flex">
              <el-input
                placeholder="Кол-во"
                type="number"
                v-model="form.value" class="input-with-select" style="margin-right: 10px"
              >
              </el-input>
              <el-input
                v-if="available_reports && available_reports[`${type || $route.params.type}_TIME`]"
                placeholder="Часы"
                v-model="form.time"
                type="number"
                class="input-with-select"
              >
              </el-input>
            </div>

            <div v-if="((type || $route.params.type) === 'JOB') && form.job.plan && !isCreateCustom">
              <span v-if="total_p || total_p === 0">Физ объем: {{ total_p }}</span>
              <span style="margin-right: 8px">П: <strong>{{ toFixedWithoutZero(form.job.plan || 0) }}</strong></span>
              <span style="margin-right: 8px">Ф: <strong>{{
                  toFixedWithoutZero(form.job.totalValue || 0)
                }}</strong></span>
              <span style="margin-right: 8px">+\-: <strong>{{
                  (toFixedWithoutZero((form.job.totalValue || 0) - (form.job.plan || 0)))
                }}</strong></span>
              <strong v-if="Number(form.job.plan)"
                      :style="{color: pStatus(findPercentage(form.job.totalValue, form.job.plan))}">
                {{ findPercentage(form.job.totalValue, form.job.plan) }}%
              </strong>
            </div>
          </div>

          <div class="select-value" v-else>
          <span
            style="width: calc(100% - 30px)"
            v-if="form.job && !isCreateCustom"><strong>{{
              form.job.name
            }}</strong>
            {{ form.job.unit && `, ${(form.job.unit.label || form.job.unit)}` }}
          </span>
            <div
              v-if="((type || $route.params.type) === 'JOB') && !isCreateCustom"
              style="display: flex; justify-content: flex-end; flex: 1; width: 100%; position: absolute; z-index: 999999; margin-left: -40px; margin-top: 2px">
              <i class="fa fa-edit" style="cursor: pointer" @click="editJob"></i>
            </div>
            <div v-if="((type || $route.params.type) !== 'TECH' && (type || $route.params.type) !== 'PROF') || (
            $store.state.project.plan && (!type || $route.params.type === 'JOB'))">
              <el-row>
                <el-col :span="12">
                  <el-input v-if="!$store.state.project.plan"
                            style="margin-right: 8px"
                            placeholder="Сменный план"
                            v-model="form.daily_plan" class="input-with-select">
                  </el-input>
                  <el-input
                    v-else
                    style="margin-right: 8px"
                    placeholder="Сменный план"
                    :value="((type || $route.params.type) === 'JOB') ? daily_plan : getProfTechPlan"
                    class="input-with-select"
                  >
                  </el-input>
                </el-col>
                <el-col :span="12">
                  <el-input
                    style="margin-left: 8px"
                    placeholder="Сменный факт"
                    @input="valueMaterials"
                    :value="form.value" class="input-with-select">
                  </el-input>
                </el-col>
              </el-row>
              <el-input
                style="margin-top: 10px; margin-right: -10px; width: calc(100% + 8px)"
                placeholder="Комментарий"
                type="textarea"
                v-model="form.comment"
              >
              </el-input>
            </div>
            <div v-else style="display: flex">
              <el-input
                placeholder="Кол-во"
                type="number"
                v-model="form.value" class="input-with-select" style="margin-right: 10px"
              >
              </el-input>
              <el-input
                v-if="available_reports && available_reports[`${type || $route.params.type}_TIME`]"
                placeholder="Часы"
                v-model="form.time"
                type="number"
                class="input-with-select"
              >
              </el-input>
            </div>

            <div class="form_job_plan" style="margin-top: 10px"
                 v-if="((type || $route.params.type) === 'JOB')">
              <span v-if="total_p || total_p === 0">Физ объем: {{ total_p }}</span>
              <span style="margin-right: 8px">П: <strong>{{ toFixedWithoutZero(form.job.plan || 0) }}</strong></span>
              <span style="margin-right: 8px">Ф: <strong>{{
                  toFixedWithoutZero(form.job.totalValue || 0)
                }}</strong></span>
              <span style="margin-right: 8px">+\-: <strong>{{
                  (toFixedWithoutZero((form.job.totalValue || 0) - (form.job.plan || 0)))
                }}</strong></span>
              <strong v-if="Number(form.job.plan)"
                      :style="{color: pStatus(findPercentage(form.job.totalValue, form.job.plan))}">
                {{ findPercentage(form.job.totalValue, form.job.plan) }}%
              </strong>
            </div>
          </div>

          <div style="margin-top: 6px">
            <div v-for="input in form.job.inputs || []">
              <div v-if="input.type === 'text'" style="margin-top: 10px">
                <strong style="color: black">{{ input.name }}
                </strong>
                <el-input
                  style="margin-top: 4px"
                  :placeholder="input.name"
                  v-model="input.value"
                  class="input-with-select"
                >
                </el-input>
              </div>
              <div v-if="input.type === 'number'" style="margin-top: 10px">
                <strong style="color: black">{{ input.name }}
                </strong>
                <el-input
                  :controls="false"
                  style="margin-top: 4px"
                  type="number"
                  :placeholder="input.name"
                  v-model="input.value"
                  class="input-with-select"
                />
              </div>
              <div v-if="input.type === 'date'" style="margin-top: 10px; display: flex; flex-direction: column">
                <strong style="color: black; margin-bottom: 8px">{{ input.name }}
                </strong>
                <el-date-picker
                  format="yyyy-MM-dd"
                  v-model="input.value"
                  type="date"
                  placeholder="Укажите дату"
                >
                </el-date-picker>
              </div>
              <div v-if="input.type === 'calc'" style="margin-top: 10px; display: flex; flex-direction: column">
                <strong style="color: black; margin-bottom: 8px">{{ input.name }}</strong>

                <el-input
                  :controls="false"
                  style="margin-top: 4px; max-width: 220px; pointer-events: none"
                  type="number"
                  :placeholder="input.name"
                  :value="getCalc(input)"
                  class="input-with-select"
                />
              </div>

              <div
                v-if="input.type.includes('materials') || input.type.includes('constructions') || input.type.includes('multiple')">
                <div class="material-title" style="margin-bottom: 8px; margin-top: 10px">
                  <strong style="color: black;">{{ input.name }}
                  </strong>
                  <span
                    v-if="showCalc(input.volumeId) && input.type.includes('multiple')"
                    @click="toFactMultiple(input)"
                    class="sum-icon" style="margin-left: 4px">&sum;</span>
                  <span
                    v-else
                    @click="toFact(input)"
                    class="sum-icon" style="margin-left: 4px">&sum;</span>
                </div>
                <filter-select
                  noTag
                  @blur="input.isLoading = false"
                  :isLoading="input.isLoading"
                  @search="(s) => searchWithoutDelay(s, input)"
                  @addNew="(name) => addNew(input, name)"
                  :addNewEnable="input.isEditable"
                  multiple
                  @select="(e) => inputMaterial(e, input)"
                  hide-label
                  @focus="searchWithoutDelay('', input)"
                  @remove="(e) => removeMaterial(e, input)"
                  v-model="input.value"
                  @input="inputOption(input)"
                  :label="input.name" :options="sortOptions(filterMaterials(input) || [], input.value, input)">
                </filter-select>
              </div>


              <div v-if="input.type === 'select' || input.type === 'zone'">
                <div class="material-title" style="margin-bottom: 8px; margin-top: 10px">
                  <strong style="color: black;">{{ input.name }}
                  </strong>
                  <span
                    v-if="showCalc(input.volumeId) && input.type.includes('multiple')"
                    @click="toFactMultiple(input)"
                    class="sum-icon" style="margin-left: 4px">&sum;</span>
                </div>
                <filter-select
                  noTag
                  @blur="input.isLoading = false"
                  @focus="searchWithoutDelay('', input)"
                  :isLoading="input.isLoading"
                  @addNew="(name) => addNew(input, name)"
                  :addNewEnable="input.isEditable"
                  :multiple="input.type.includes('multiple')"
                  @input="(opt) => inputOption(input, opt)"
                  hide-label
                  @search="(s) => searchWithoutDelay(s, input)"
                  v-model="input.value"
                  :label="input.name"
                  :options="sortOptions(input.type.includes('multiple') ? (filterMaterials(input) || []) : (input.options || []), input.value, input)">
                </filter-select>
              </div>

              <div v-if="input.type === 'population'" style="    margin-bottom: 8px; margin-top: 10px;">
                <strong style="color: black">{{ input.name }} <i style="cursor: pointer" class="fa fa-edit"
                                                                 @click="openAddProf"/></strong>
                <el-row style="margin-top: 8px">
                  <el-col :span="12">
                    <el-form-item>
                      <el-input disabled style="margin-right: 8px" :value="`${profValue.fact || 0} кол-во`">
                      </el-input>
                    </el-form-item>
                  </el-col>
                  <el-col :span="12" v-if="available_reports && available_reports[`PROF_TIME`]">
                    <el-form-item>
                      <el-input disabled style="margin-left: 8px" :value="`${profValue.time || 0} часы`"/>
                    </el-form-item>
                  </el-col>
                </el-row>
              </div>


              <template v-if="input.type === 'nomenclature'">

                <NomenclatureInput
                  :options_works="options_works"
                  :job="form"
                  :dirs="dirs"
                  @toFact="toFactNomenclature" :selectValuesProp="input.selectValues" :nomenclature="input"
                  @save="(e) => saveNomennclature(e, input)"/>
              </template>

              <div v-if="input.type === 'tech'" style="    margin-bottom: 8px; margin-top: 10px;">
                <strong style="color: black">{{ input.name }} <i style="cursor: pointer" class="fa fa-edit"
                                                                 @click="openAddTech"/></strong>
                <el-row style="margin-top: 8px">
                  <el-col :span="12">
                    <el-form-item>
                      <el-input disabled style="margin-right: 8px" :value="`${techValue.fact || 0} кол-во`">
                      </el-input>
                    </el-form-item>
                  </el-col>
                  <el-col :span="12" v-if="available_reports && available_reports[`TECH_TIME`]">
                    <el-form-item>
                      <el-input disabled style="margin-left: 8px" :value="`${techValue.time || 0} часы`"/>
                    </el-form-item>
                  </el-col>
                </el-row>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div v-if="!isCreateJob && !approve" slot="footer" class="dialog-footer">
        <el-button
          style="margin-left: 0; padding: 12px 8px"
          type="danger"
          v-if="isEdit"
          @click="remove"
        >Удалить
        </el-button>
        <el-button
          style="margin-left: 0; padding: 12px 8px"
          type="primary"
          v-if="!!form.job"
          @click="save"
        >Сохранить
        </el-button>
        <el-button style="margin-left: 0; padding: 12px 8px" @click="close">
          Закрыть
        </el-button>
      </div>
    </el-dialog>

    <AddNewOption @close="" ref="addNewOption" @new-option="addNewInput"/>
    <el-dialog
      :show-close="false"
      :title="selectMaterial.label"
      :visible.sync="openDialogMaterials"
      width="30%"
      center
    >
      <div v-if="selectMaterial && selectMaterial.details" :class="{'disable-report': approve}">
        <template v-if="!selectMaterial.type.includes('multiple')">
          <el-input
            :controls="false"
            style="margin-top: 4px"
            type="number"
            @input="inputMat(selectMaterial)"
            placeholder="Значение"
            v-model="selectMaterial.fact"
            class="input-with-select">
            <template slot="append">{{ selectMaterial.details[1] && selectMaterial.details[1].label }}</template>
          </el-input>
          <div style="display: flex; align-items: center; margin-top: 8px">
            <span v-if="!selectMaterial.withoutPlan">План: <strong>{{ selectMaterial.details[2] || 0 }}</strong></span>
          </div>


          <template v-if="selectMaterial.type.includes('constructions')">
            <el-input
              :controls="false"
              style="margin-top: 22px"
              type="number"
              placeholder="Значение"
              v-model="selectMaterial.factUnit"
              class="input-with-select">
              <template slot="append">{{ selectMaterial.details[3] && selectMaterial.details[3].label }}</template>
            </el-input>
            <div style="display: flex; align-items: center; margin-top: 8px" v-if="!selectMaterial.withoutPlan">
              <span>План на ед: <strong>{{ selectMaterial.details[4] || 0 }}</strong></span>
            </div>
          </template>
        </template>

        <div v-if="selectMaterial.isDetail" style="margin-top: 22px">
          <el-input v-model="selectMaterial.detail" placeholder="Примечание"></el-input>
        </div>

        <div style="display: flex; align-items: center; margin-top: 12px"
             v-if="!selectMaterial.withoutPlan && !selectMaterial.type.includes('multiple')">
          <el-checkbox
            v-model="selectMaterial.inVolume"
            label="в объем"
          ></el-checkbox>
        </div>
      </div>

      <div style="margin-top: 32px; display: flex; justify-content: flex-end">

        <el-button type="primary" @click="saveMaterial(true)">Сохранить</el-button>
        <el-button @click="closeMaterial">Закрыть</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import firebase from 'firebase';
import JobsCreate from '../../Jobs/Create';
import _, {debounce, orderBy} from 'lodash';
import MaterialsCreate from '../../Jobs/Materials';
import {BigNumber} from "bignumber.js";
import {filterJobs} from "../../../../utils/filterJobs";
import {getPermission} from "../../../../firestore/permission";
import UnitSelect from '../../components/unitSelect';
import {calculateProfTechByJobs} from "../../../../firestore/plan";
import {toFixedWithoutZero, toFloat} from "../../../../utils/numberUtils";
import FilterSelect from "../../../../components/FilterSelect";
import {getZonesOptions} from "../../../../firestore/inputs";
import AddNewOption from "./AddNewOption";
import {v4 as uuidv4} from 'uuid';
import NomenclatureInput from "./NomenclatureInput";
import dayjs from 'dayjs'
import {isCache} from "../../../../plugins/firebase";
import CyrillicToTranslit from "cyrillic-to-translit-js";

function percentage(num, per) {
  return new BigNumber(num).dividedBy(100)
    .multipliedBy(per).toNumber()
}


export default {
  name: 'AddJobs',
  components: {NomenclatureInput, AddNewOption, FilterSelect, MaterialsCreate, JobsCreate, UnitSelect},
  props: ['obj', 'index', 'type', 'unit_prop', 'report', 'propsType', 'uidData', 'childForm', 'approve', 'options_works', 'dirs'],
  data() {
    return {
      search: '',
      tr: {
        JOB: 'работу',
        PROF: 'профессию',
        TECH: 'технику',
        MATERIALS: 'материалы',
      },
      tra: {
        JOB: 'работа',
        PROF: 'профессия',
        TECH: 'техника',
        MATERIALS: 'материалы',
      },
      prevZone: null,
      dialogObject: false,
      isCreateJob: false,
      unit: '',
      total_p: null,
      jobs: [],
      input: {},
      inputs: [],
      openDialogMaterials: false,
      selectMaterial: {},
      step: 0,
      editIndex: null,
      role: 'admin',
      savedJob: null,
      total: 0,
      isCreateCustom: false,
      isEdit: false,
      zoneLock: false,
      profValue: {
        time: '',
        fact: ''
      },
      techValue: {
        time: 0,
        fact: 0
      },
      form: {
        value: '',
        time: '',
        plan: 0,
        job: null,
        work_type: {},
        daily_plan: '',
        comment: '',
        inputs: []
      },
      permission: null,
      available_reports: {},
    };
  },

  async mounted() {
    this.permission = await getPermission(this.$store.state.project.id, this.$store.state.company.uid || authFirestore.currentUser.uid, (this.$store.state.project.plan && this.$store.state.project.plan.id));

    myFirestore
      .collection('projects')
      .doc(this.$store.state.project.id).get().then((sub) => {
      const data = sub.data();
      if (data) {
        const rules = data.rules;
        if (rules) {
          this.role = rules[authFirestore.currentUser.uid];

          if (data.isDemo) {
            this.role = 'admin';
          }
          this.loading = false;
        }
      }
    });
    this.available_reports = this.$store.state.project.available_reports;

    this.fetchJobs();

    getZonesOptions(this.$store.state.project.id)

    let dir = null

    const path = 'INPUTS_' + JSON.stringify({
      id: this.$store.state.project.id, dirs: [(dir && dir.dir) || 'all']
    })

    const cache = localStorage.getItem(path);

    if (!cache || Number(JSON.parse(cache).expire) < dayjs().unix()) {

      const inputs = await myFirestore
        .collection('projects')
        .doc(this.$store.state.project.id)
        .collection('inputs')
        .where(`dirs`, 'array-contains-any', [(dir && dir.dir) || 'all'])
        .get()

      const cacheResult = []

      inputs.forEach((input) => {
        const data = input.data();
        cacheResult.push({...data, id: input.id})
      })

      if (isCache) {
        localStorage.setItem(path, JSON.stringify({result: cacheResult, expire: dayjs().add(10, 'minute').unix()}))
      }
    }
  },
  watch: {
    'childForm': {
      deep: true,
      async handler() {
        this.getProfValue()
      }
    },
    'form.job': {
      deep: true,
      async handler(job = {}) {
        if (!job) {
          return
        }

        const n = job && job.inputs || []

        const nextZone = n.find(({id}) => id === 'zone')
        if ((nextZone && nextZone.value && nextZone.value.value) !== (this.prevZone && this.prevZone.value && this.prevZone.value.value)) {
          let inputs = [...((this.form.job && this.form.job.inputs) || [])]

          inputs = inputs.map((input) => {
            if ((input.type.includes('materials') || input.type.includes('constructions') || input.type.includes('multiple')) && !this.zoneLock) {
              return {
                ...input,
                options: [...(input.options || [])].map((option) => {
                  if (!option.isZone && !option.zoneId) {
                    return option
                  }
                  return {
                    ...option,
                    label: option.value
                  }
                }),
                value: [...(input.value || [])].filter((v) => !v.zoneId)
              }
            }

            if (input.type === 'zone') {
              // console.log(input.value =  dir.available_objects., 'input')
              const work = this.options_works.find(({id}) => id === job.work_type)

              if (work && work.dir) {
                const dir = this.dirs.find(({id}) => id === work.dir);

                if (dir && dir.defaultZone && !input.value) {
                  setTimeout(() => {
                    input.value = input.options.find((d) => dir.defaultZone === d.value);
                  }, 1000)
                }

                if (dir && dir.usePermission) {
                  input.options = input.options.filter((d) => dir.available_objects.includes(d.value) || !d.value)
                }
              }
            }

            return input
          })


          // const inputsValues = {
          //   ...inputs,
          // }


          this.form.job = {
            ...this.form.job,
            inputs
          }
        }

        this.prevZone = {...nextZone};
      }
    },
    obj() {
      this.fetchJobs();
    },
    dialogObject(d) {
      if (d === true) {
        myFirestore
          .collection('projects')
          .doc(this.$store.state.project.id).get().then((sub) => {
          const data = sub.data();
          if (data) {
            const rules = data.rules;
            if (rules) {
              this.role = rules[authFirestore.currentUser.uid];

              if (data.isDemo) {
                this.role = 'admin';
              }
              this.loading = false;
            }
          }
        });
        this.available_reports = this.$store.state.project.available_reports;

        this.fetchJobs();
      }
    }
  },

  computed: {
    filteredList() {
      return this.jobs.filter(job => {
        return job.name.toLowerCase().includes(this.search.toLowerCase());
      });
    },
    daily_plan() {
      const datetime = dayjs(this.report.datetime).format('DD.MM.YYYY');
      try {
        this.form.daily_plan = this.form.job.volumes[this.report.turn.value - 1][datetime] || 0;
        return this.form.daily_plan
      } catch (e) {
        return 0;
      }
    }
  },
  asyncComputed: {
    async getProfTechPlan() {
      try {
        return await calculateProfTechByJobs({
          planID: this.$store.state.project.plan && this.$store.state.project.plan.id,
          projectID: this.$store.state.project.id,
          objectID: (this.obj && this.obj.id) || null,
          permission: this.permission,
          date: this.report.datetime,
          profTechId: (this.form.job && this.form.job.id) || null,
          type: this.type || this.$route.params.type,
          turn: (this.report.turn && this.report.turn.value) || 1
        });
      } catch (e) {
        console.log(e, 'e')
        return null
      }
    }
  },
  methods: {
    searchWithoutDelay(search, input) {
      if (!input.type.includes('L')) {
        return
      }
      const index = this.form.job.inputs.findIndex(({id}) => id === input.id)
      this.form.job.inputs[index].isLoading = true
      this.form.job = {
        ...this.form.job,
      }
      this.searchL(search, input)
    },
    searchL: debounce(async function (search, input) {
      const index = this.form.job.inputs.findIndex(({id}) => id === input.id)
      this.form.job.inputs[index].isLoading = true
      this.form.job = {
        ...this.form.job,
      }

      const zone = this.form.job.inputs.find(({id}) => id === 'zone')
      if (!input.type.includes('L')) {
        return
      }
      input.isLoading = true


      let resp = null


      if (search && search.length) {
        const cyrillicToTranslit = new CyrillicToTranslit();


        const txt = String(cyrillicToTranslit.transform(search).toLowerCase())
        const txtArray = txt.split(' ')
        if (zone && zone.value && zone.value.value) {
          const query = await myFirestore
            .collection('projects')
            .doc(this.$store.state.project.id)
            .collection('inputs')
            .doc(input.id)
            .collection('optionsList')
            .where('zoneId', '==', zone.value.value)
            .where('searchName', 'array-contains', txtArray[txtArray.length - 1])
          resp = await query.limit(100).get()
        } else {
          const query = await myFirestore
            .collection('projects')
            .doc(this.$store.state.project.id)
            .collection('inputs')
            .doc(input.id)
            .collection('optionsList')
            .where('searchName', 'array-contains', txtArray[txtArray.length - 1])
          resp = await query.limit(100).get()
        }

      } else {
        if (zone && zone.value && zone.value.value) {
          resp = await myFirestore
            .collection('projects')
            .doc(this.$store.state.project.id)
            .collection('inputs')
            .doc(input.id)
            .collection('optionsList')
            .where('zoneId', '==', zone.value.value).limit(100).get()
        } else {
          resp = await myFirestore
            .collection('projects')
            .doc(this.$store.state.project.id)
            .collection('inputs')
            .doc(input.id)
            .collection('optionsList')
            .orderBy('index', 'asc')
            .limit(100).get()
        }
        // const query = await myFirestore
        //   .collection('projects')
        //   .doc(this.$store.state.project.id)
        //   .collection('inputs')
        //   .doc(input.id)
        //   .collection('optionsList')
        //
        // if (zone && zone.value && zone.value.value) {
        //   query.where('zoneId', '==', zone.value.value).orderBy('index', 'asc')
        // } else {
        //   query.orderBy('index', 'asc')
        // }
        //
        // resp = await query.limit(100).get()

      }

      const result = []
      resp.forEach((d) => {
        result.push(
          {
            id: d.id,
            ...d.data(),
          }
        )
      })

      console.log(result, 'result')

      this.form.job.inputs[index].options = [...orderBy(result, 'index', 'asc')]

      this.form.job.inputs[index].isLoading = false
      this.form.job = {
        ...this.form.job,
      }

      // console.log(search, input)
      //   const resp = await myFirestore
      //     .collection('projects')
      //     .doc(this.$store.state.project.id)
      //     .collection('inputs')
      //     .doc(input.id)
      //     .collection('optionsList').limit(100).get()
    }, 500),
    saveNomennclature(d, input) {
      const index = this.form.job.inputs.findIndex(({id}) => input.id === id)
      this.form.job.inputs[index].selectValues = d
      if (!this.form.job.inputs[index].selectValues || !Object.keys(this.form.job.inputs[index].selectValues).length) {
        this.form.job.inputs[index].selectValues = null
      }

      this.form.job = {...this.form.job}
    },
    pStatus(n) {
      if (n >= 99) {
        return '#7CB342'
      }

      if (n > 85) {
        return '#F57C00'
      }

      return '#D32F2F'
    },
    findPercentage(a, b) {
      if (!a) {
        return 0
      }

      if (!b) {
        return 100
      }


      return Number((Number(a || 0) / Number(b)) * 100).toFixed(0);
    },
    createCustom() {
      this.form.job = {
        name: '',
        unit: '',
        id: '01',
        work_type: 'custom',
        dir: null
      }
      this.selectJob(this.form.job)
      this.isCreateCustom = true
    },
    createJob() {
      this.isCreateJob = true;
    },
    async getJob(jobId) {
      if (jobId && jobId.length > 3) {
        let jobData = null

        const path = 'JOB_' + JSON.stringify({
          id: jobId
        })

        const cache = localStorage.getItem(path);

        if (!cache || Number(JSON.parse(cache).expire) < dayjs().unix()) {
          const job = await this.fire()
            .collection('jobs').doc(jobId).get()
          jobData = job.data()

          if (isCache) {
            localStorage.setItem(path, JSON.stringify({jobData, expire: dayjs().add(10, 'minute').unix()}))
          }

        } else {
          jobData = JSON.parse(localStorage.getItem(path)).jobData
        }

        this.form.job = {
          ...this.form.job,
          totalValue: jobData.totalValue || 0,
          plan: jobData.plan || 0
        }

        this.form = {
          ...this.form
        }
      }
    },
    sortOptions(options, value, input) {
      if (Array.isArray(value)) {
        const values = value || [];

        const optionsWithoutValues = options.filter((o) => !(values || []).find((v) => v.uid === o.uid && v.value === o.value));
        return [..._.orderBy(values, ['label'], ['desc']), ...optionsWithoutValues] //_.orderBy(options, ['label'], ['desc'])
      } else {
        return options
      }
    },
    getProfValue() {
      if (this.childForm.PROF && this.childForm.PROF.jobs && this.form.uid) {
        const jobsAll = _.flatMapDeep(this.childForm.PROF.jobs)
        const findLinked = jobsAll.filter(({linkedUid}) => linkedUid === this.form.uid)
        const fact = findLinked.reduce(
          (accumulator, currentValue) => accumulator + Number(currentValue.value), 0
        )

        let time = findLinked.reduce(
          (accumulator, currentValue) => accumulator + new BigNumber(currentValue.value || 0).multipliedBy(currentValue.time || 0).toNumber(), 0
        )

        if (!fact && !time) {
          time = findLinked.reduce(
            (accumulator, currentValue) => accumulator + Number(currentValue.time), 0
          )
        }

        console.log(findLinked, 'findLinked')

        this.profValue = {
          time: !findLinked.length || findLinked.find(({time}) => time === '') ? null : time,
          fact: !findLinked.length || findLinked.find(({value}) => value === '') ? null : fact,
        };
      }
    },
    getTechValue() {
      if (this.childForm.TECH && this.childForm.TECH.jobs && this.form.uid) {
        const jobsAll = _.flatMapDeep(this.childForm.TECH.jobs)
        const findLinked = jobsAll.filter(({linkedUid}) => linkedUid === this.form.uid)
        const fact = findLinked.reduce(
          (accumulator, currentValue) => accumulator + Number(currentValue.value), 0
        )

        let time = findLinked.reduce(
          (accumulator, currentValue) => accumulator + new BigNumber(currentValue.value || 0).multipliedBy(currentValue.time || 0).toNumber(), 0
        )

        if (!fact && !time) {
          time = findLinked.reduce(
            (accumulator, currentValue) => accumulator + Number(currentValue.time), 0
          )
        }


        this.techValue = {
          time,
          fact
        };
      }
    },
    openAddProf() {
      this.form.uid = this.form.uid || uuidv4()
      this.$emit('add-prof', {
        uid: this.form.uid,
        job: JSON.parse(JSON.stringify(this.form.job))
      })
    },
    openAddTech() {
      this.form.uid = this.form.uid || uuidv4()
      this.$emit('add-tech', {
        uid: this.form.uid,
        job: this.form.job
      })
    },
    showCalc(obj) {
      try {
        return !!Object.values(obj).find((o) => o)
      } catch (e) {
        return false
      }
    },
    toFactMultiple(input) {
      let id = Object.values(input.volumeId).findIndex((o) => o)
      let result = 0
      input.value.forEach(({details}) => {
        result += Number(details[id + 1])
      })

      this.form.value = result
      this.form = {...this.form}
    },
    toFactNomenclature(result) {
      this.form.value = result
      this.form = {...this.form}
    },
    inputMat(selectMaterial) {
      if (selectMaterial.withoutPlan) {
        return
      }
      selectMaterial.factUnit = new BigNumber(selectMaterial.fact || 0).multipliedBy(selectMaterial.details[4] || 0).toNumber()
    },
    toFact(input) {
      let result = 0

      input.value.forEach((value) => {
        if (value.inVolume) {
          result = new BigNumber(result)
            .plus(input.type.includes('constructions') ? value.factUnit : value.fact).toNumber()
        }
      })

      this.form.value = result
      this.form = {...this.form}
    },
    saveMaterial(flag) {
      /// НЕ ТРОГАТЬ
      const index = this.form.job.inputs.findIndex(({id}) => this.selectMaterial.parentId === id)

      const option = this.form.job.inputs[index].options.find(({value}) => value === this.selectMaterial.value);
      if (!option) {
        this.form.job.inputs[index].options.push({
          details: this.selectMaterial.details,
          id: this.selectMaterial.id,
          index: this.selectMaterial.index,
          isCreate: this.selectMaterial.isCreate,
          label: this.selectMaterial.label,
          uid: this.selectMaterial.uid,
          value: this.selectMaterial.value,
          zoneId: this.selectMaterial.zoneId
        })

      }
      // options.find(({value}) => )
      const childIndex = this.form.job.inputs[index].options.findLastIndex(
        ({
           uid,
           value,
           label
         }) => uid === this.selectMaterial.uid
          && this.selectMaterial.value.trim() === value.trim()
          && this.selectMaterial.label.trim() === label.trim()
      );

      if (this.selectMaterial.isDetail && this.form.job.inputs[index].options[childIndex]) {
        const input = JSON.parse(JSON.stringify(this.form.job.inputs[index].options[childIndex]))
        const option = {
          ...JSON.parse(JSON.stringify(this.form.job.inputs[index].options[childIndex])),
          value: JSON.parse(JSON.stringify(this.form.job.inputs[index].options[childIndex])).value,
          label: input.originalLabel || input.label,
        }

        this.form.job.inputs[index].options.push({...option})
      }


      if ((this.selectMaterial.type.includes('multiple') || flag) && this.form.job.inputs[index].options[childIndex]) {
        this.form.job.inputs[index].options[childIndex].label = '' + this.selectMaterial.value + (this.selectMaterial.fact ? ' - ' + this.selectMaterial.fact : '') + ' ' + ((this.selectMaterial.details[1] && this.selectMaterial.details[1].label) || '')
      }


      // if(this.selectMaterial.type === 'materials') {
      this.form.job.inputs[index].options[childIndex].originalLabel = '' + this.form.job.inputs[index].options[childIndex].value
      // }

      if (this.selectMaterial.type.includes('multiple')) {
        try {

          const trueKeys = Object.keys(this.form.job.inputs[index].volumeId).filter(key => this.form.job.inputs[index].volumeId[key] === true);

          const details = this.form.job.inputs[index].options[childIndex].details
          if (trueKeys && trueKeys.length) {
            let sumKey = 0;
            let label = ''

            trueKeys.forEach((key) => {
              if (details[key] && !isNaN(details[key])) {
                sumKey += Number(details[key])
                label = this.form.job.inputs[index].labels[key]
              }
            })


            this.form.job.inputs[index].options[childIndex].originalLabel = '' + this.form.job.inputs[index].options[childIndex].value

            this.form.job.inputs[index].options[childIndex].label = '' + this.selectMaterial.value + ' - (' + sumKey + ' ' + label + ')'
          } else if (!flag) {
            return;
          }
        } catch (e) {
          console.error(e)
          if (!flag) {
            return
          }
        }
      }


      this.form.job.inputs[index].options[childIndex].value = JSON.parse(JSON.stringify(this.form.job.inputs[index].options[childIndex].label))
      this.form.job.inputs[index].options[childIndex].fact = this.selectMaterial.fact;
      this.form.job.inputs[index].options[childIndex].inVolume = this.selectMaterial.inVolume;


      const valueIndex = this.form.job.inputs[index].value.findLastIndex(({uid}) => uid === this.selectMaterial.uid);

      this.form.job.inputs[index].value[valueIndex].label = this.form.job.inputs[index].options[childIndex].label
      this.form.job.inputs[index].value[valueIndex].fact = this.selectMaterial.fact;
      if (this.selectMaterial.isDetail) {
        this.form.job.inputs[index].value[valueIndex].detail = this.selectMaterial.detail
      }


      if (this.selectMaterial.inVolume && !this.selectMaterial.withoutPlan) {
        this.form.job.inputs[index].options[childIndex].label = '• ' + this.form.job.inputs[index].options[childIndex].label;
        this.form.job.inputs[index].value[valueIndex].inVolume = true
      }

      if (this.form.job.inputs[index].type.includes('constructions')) {
        this.form.job.inputs[index].value[valueIndex].factUnit = this.selectMaterial.factUnit;
        this.form.job.inputs[index].options[childIndex].label += isNaN(this.selectMaterial.factUnit) ? '' :
          (this.selectMaterial.details[3] || this.selectMaterial.factUnit ? ` (${this.selectMaterial.factUnit} ${(this.selectMaterial.details[3] && this.selectMaterial.details[3].label)})` : '')
      }

      if (this.selectMaterial.isDetail && this.selectMaterial.detail) {
        this.form.job.inputs[index].options[childIndex].label += ' (' + this.selectMaterial.detail + ')'
      }


      this.form.job.inputs[index].value[valueIndex].label = JSON.parse(JSON.stringify(this.form.job.inputs[index].options[childIndex].label))
      this.form.job.inputs[index].value[valueIndex].value = JSON.parse(JSON.stringify(this.form.job.inputs[index].options[childIndex].label))
      this.form.job.inputs[index].options[childIndex].value = JSON.parse(JSON.stringify(this.form.job.inputs[index].options[childIndex].label))

      this.form = {...this.form}
      this.openDialogMaterials = false;
      this.selectMaterial = {}

    },
    closeMaterial() {
      this.openDialogMaterials = false;
      const index = this.form.job.inputs.findIndex(({id}) => this.selectMaterial.parentId === id)

      this.form.job.inputs[index].value = this.form.job.inputs[index].value.filter(({
                                                                                      uid,
                                                                                      value
                                                                                    }) => uid !== this.selectMaterial.uid || value !== this.selectMaterial.value)
      this.form.job.inputs = [...this.form.job.inputs]
      setTimeout(() => {
        this.selectMaterial = {}
      }, 200)
    },
    removeMaterial(e, input) {
      const index = input.options.findIndex(({uid, value, label}) => uid === e.uid && value.trim() === e.value.trim())

      if (input.options[index] && input.options[index].originalLabel) {
        input.options[index].label = '' + input.options[index].originalLabel;
        input.options[index].value = '' + input.options[index].originalLabel;
      }

      if (index !== -1 && input.options.filter((o) => o.uid === e.uid).length > 1) {
        input.options.splice(index, 1)
      }

      this.form = {...this.form}
    },
    filterMaterials(input) {
      try {
        if (!input.isZone) {
          return [...(input.options || [])].filter((option) => !option.zoneId)
        }

        const zone = this.form.job.inputs.find(({id}) => id === 'zone').value || {value: 'all'}
        return [...(input.options || [])].filter((option) => !option.zoneId || option.zoneId === zone.value);
      } catch (e) {
        return []
      }
    },
    getCalc(input) {
      let n1 = 0
      let n2 = 0

      const findValue = (value) => {
        const res = this.form.job.inputs.find(({id}) => id === value)
        return (res && res.value) || 0
      }

      if (input.options[0].value === 'fact') {
        n1 = this.form.value
      } else {
        n1 = findValue(input.options[0].value)
      }

      if (input.options[1].value === 'fact') {
        n2 = this.form.value
      } else {
        n2 = findValue(input.options[1].value)
      }

      const operators = {
        '+': function (x, y) {
          return Number(x) + Number(y);
        },
        '-': function (x, y) {
          return Number(x) - Number(y);
        },
        '*': function (x, y) {
          return Number(x) * Number(y);
        },
        '/': function (x, y) {
          return Number(x) / Number(y);
        }
      };

      const result = operators[input.operation.value](n1, n2)
      input.value = result

      return result
    },
    inputMaterial(e, input) {

      this.selectMaterial = {
        ...e,
        fact: '',
        factUnit: '',
        detail: '',
        withoutPlan: input.withoutPlan,
        isDetail: input.isDetail,
        inVolume: input.type.includes('constructions'),
        parentId: input.id,
        type: input.type
      };

      if (!input.type.includes('multiple') || input.isDetail) {
        this.openDialogMaterials = true
      }

      if (input.type.includes('multiple') && !input.isDetail) {
        this.saveMaterial()
      }
    },
    inputOption(input, opt) {
      if (input.type.includes('multiple') && input.volumeId && opt) {
        const indexInput = this.form.job.inputs.findIndex(({id}) => input.id === id)

        const index = Object.values(input.volumeId).findIndex((d) => d)
        this.form.job.inputs[indexInput].options = this.form.job.inputs[indexInput].options.map((option) => {
          return {
            ...option,
            label: option.value,
          }
        })


        if (input.isDetail) {
          this.openDialogMaterials = true


          this.selectMaterial = {
            ...opt[opt.length - 1],
            fact: '',
            factUnit: '',
            detail: '',
            isDetail: input.isDetail,
            parentId: input.id,
            originalLabel: opt[opt.length - 1].value,
            details: [],
            type: input.type
          };
        }

        opt.forEach((o) => {
          const childIndex = this.form.job.inputs[indexInput].options.findIndex(({uid}) => uid === o.uid);
          const valueIndex = this.form.job.inputs[indexInput].value.findIndex(({uid}) => uid === o.uid);

          this.form.job.inputs[indexInput].options[childIndex].label = o.value + ` ${o.details[index + 1] ? '(' + o.details[index + 1] + ' ' + input.labels[index + 1] + ')' : ''}`;
          this.form.job.inputs[indexInput].value[valueIndex].label = this.form.job.inputs[indexInput].options[childIndex].label
          this.form.job.inputs[indexInput].options[childIndex].originalLabel = String(o.value);
          this.form.job.inputs[indexInput].value[valueIndex].originalLabel = String(o.value);
        })

      }

      if (input.type === 'zone') {
        this.zoneLock = false
      }
      this.form = {
        ...this.form
      }
    },
    addNewInput(d, id, value) {

      const index = this.form.job.inputs.findIndex((job) => job.id === id)
      const data = JSON.parse(JSON.stringify(d))

      this.form.job.inputs[index] = JSON.parse(JSON.stringify({
        ...data,
        value: data.type === 'select' ? value : [...(this.form.job.inputs[index].value || []), value],
        id: id,
      }))

      this.inputOption(this.form.job.inputs[index], this.form.job.inputs[index].value)

      this.form = JSON.parse(JSON.stringify({
        ...this.form
      }))

      if (data.type.includes('materials') || data.type.includes('constructions') || (data.type.includes('multiple') && data.isDetail)) {
        this.openDialogMaterials = true
        const options = this.form.job.inputs[index].options;
        this.selectMaterial = {
          ...this.form.job.inputs[index].options[options.length - 1],
          fact: '',
          factUnit: '',
          isDetail: this.form.job.inputs[index].isDetail,
          inVolume: data.type.includes('constructions'),
          parentId: id,
          withoutPlan: this.form.job.inputs[index].withoutPlan,
          type: data.type,
        };
      }
    },
    addNew(data, name) {
      this.input = data;
      let zone = null
      try {
        zone = this.form.job.inputs.find(({id}) => id === 'zone').value || null
      } catch (e) {
      }

      this.$refs.addNewOption.open({
        zone,
        data, name
      })
    },
    async editJob() {
      this.savedJob = null;
      this.savedJob = JSON.parse(JSON.stringify(this.form.job))
      this.form.job = null
      await this.getJob(this.savedJob.id)
    },
    async selectJob(job = {}) {
      this.form.job = {
        ...(this.form.job || {}),
        ...job
      }

      await this.getJob(this.form.job.id)

      if (this.form.job && ((this.type || this.$route.params.type) === 'JOB')) {
        let dir = {dir: null};
        let zones = []
        const result = []

        const pathWork = 'WORK_TYPE_' + JSON.stringify({
          id: this.$store.state.project.id,
          work: this.form.job.work_type,
        })
        if (this.form.job.work_type) {
          const cacheWork = localStorage.getItem(pathWork);

          if (!cacheWork || Number(JSON.parse(cacheWork).expire) < dayjs().unix()) {


            if(this.form.job.work_type !== 'custom') {
              dir = (await myFirestore
                .collection('projects')
                .doc(this.$store.state.project.id)
                .collection('works_type')
                .doc(this.form.job.work_type).get()).data()
            }

            if (isCache) {
              localStorage.setItem(pathWork, JSON.stringify({dir, expire: dayjs().add(10, 'minute').unix()}))
            }
          } else {
            dir = JSON.parse(localStorage.getItem(pathWork)).dir
          }
        }


        const zoneDirs = this.$store.state.project.zoneDirs || []

        if (zoneDirs.includes(((dir && dir.dir) || 'all'))) {
          zones = await getZonesOptions(this.$store.state.project.id)

          if (this.savedJob && this.savedJob.inputs) {

            const v = this.savedJob.inputs.find(({id}) => id === 'zone')

            if (v) {
              result.push({
                options: zones,
                name: 'Зона работы',
                index: 0,
                type: 'zone',
                value: v.value,
                id: 'zone'
              })
            }
          } else {
            result.push({
              options: zones,
              name: 'Зона работы',
              index: 0,
              type: 'zone',
              value: null,
              id: 'zone'
            })
          }
        }

        const path = 'INPUTS_' + JSON.stringify({
          id: this.$store.state.project.id, dirs: [(dir && dir.dir) || 'all']
        })

        const cache = localStorage.getItem(path);

        if (!cache || Number(JSON.parse(cache).expire) < dayjs().unix()) {

          console.log(dir.dir, 'dir.dir')

          const inputs = await myFirestore
            .collection('projects')
            .doc(this.$store.state.project.id)
            .collection('inputs')
            .where(`dirs`, 'array-contains-any', [(dir && dir.dir) || 'all'])
            .get()

          const cacheResult = []

          inputs.forEach((input) => {
            const data = input.data();

            cacheResult.push({...data, id: input.id})
            if (!data.type) {
              data.type = {
                label: 'Текст',
                value: 'text',
              }
            }
            delete data.checked;
            const dataResult = {
              ...data,
              options: data.options,
              type: data.type.value || data.type,
              value: null,
              id: input.id
            }

            if (this.savedJob && this.savedJob.inputs) {
              const v = this.savedJob.inputs.find(({id}) => id === input.id)
              if (v) {
                dataResult.value = v.value
                dataResult.selectValues = v.selectValues || null

              }
            }

            result.push({...dataResult})
          })

          for (let i in result) {
            if (result[i].type && result[i].type.includes('L')) {
              result[i].isLoading = false;
              const resp = await myFirestore
                .collection('projects')
                .doc(this.$store.state.project.id)
                .collection('inputs')
                .doc(result[i].id)
                .collection('optionsList')
                .orderBy('index', 'asc')
                .limit(100).get()

              result[i].options = []
              resp.forEach((d) => {
                result[i].options.push({
                  id: d.id,
                  ...d.data(),
                })
              })

            }
          }

          this.form.job.inputs = _.orderBy(result, 'index', ['asc'])
          this.form.job = {...this.form.job}

          if (isCache) {
            localStorage.setItem(path, JSON.stringify({result: cacheResult, expire: dayjs().add(10, 'minute').unix()}))
          }
        } else {
          const resultInputs = JSON.parse(localStorage.getItem(path)).result
          const result = []

          resultInputs.forEach((data) => {
            if (!data.type) {
              data.type = {
                label: 'Текст',
                value: 'text',
              }
            }
            delete data.checked;
            const dataResult = {
              ...data,
              options: data.options,
              type: data.type.value || data.type,
              value: null,
              id: data.id
            }

            if (this.savedJob && this.savedJob.inputs) {
              const v = this.savedJob.inputs.find(({id}) => id === data.id)
              if (v) {
                dataResult.value = v.value
              }
            }

            result.push({...dataResult})
          })

          this.form.job.inputs = _.orderBy(result, 'index', ['asc'])
          this.form.job = {...this.form.job}
        }

      }
    },
    toFixedWithoutZero,
    remove() {
      this.$emit('remove', this.editIndex)
      setTimeout(() => {
        this.close()
      }, 10)
    },
    fire() {
      if (this.$route.query.plan || (this.$store.state.project.plan && this.$store.state.project.plan.id) && (this.type || this.$route.params.type) === 'JOB') {
        return myFirestore
          .collection('projects')
          .doc(this.$store.state.project.id)
          .collection('plan')
          .doc(this.$route.query.plan || (this.$store.state.project.plan && this.$store.state.project.plan.id))
      }
      return myFirestore
        .collection('projects')
        .doc(this.$store.state.project.id)
    },
    valueMaterials(n) {

      if (n.match(/^[0-9]+$/) || /%$/.test(n) || /,$/.test(n) || /.$/.test(n) || !String(n).length) {
        this.form.value = String(n).replace(',', '.');

        if ((/%$/.test(n) && (this.type || this.$route.params.type) === 'JOB') && this.form.job.plan) {
          return this.total_p = percentage(Number(this.form.job.plan), Number(this.form.value.replace('%', '')));
        } else {

          this.total = new BigNumber(String(this.form.value).replace(',', '.'))
            .multipliedBy(String(this.form.job.unit_value).replace(',', '.')).toNumber()
        }

        this.total_p = null;
      }
    },
    open() {
      this.dialogObject = true;
      this.step = 0;
      this.total_p = null;
      this.total = 0;

      this.form = {
        value: '',
        time: '',
        job: null,
        work_type: {},
      };
      this.isCreateJob = false;
    },
    openWithForm(jobForm, index) {
      this.zoneLock = true;
      this.dialogObject = true;
      this.prevZone = null

      this.editIndex = index;

      if (jobForm) {
        this.form = {
          ...this.form,
          ...jobForm
        }


        this.savedJob = JSON.parse(JSON.stringify(this.form.job))

        if (jobForm.job) {
          this.form.job = JSON.parse(JSON.stringify(jobForm.job))
          this.selectJob({})
        }

        this.isEdit = true;

        this.form.daily_plan = this.form.plan

        this.getProfValue()

        this.getTechValue()

      }
    },
    fetchJobs() {
      let req = null;
      this.isCreateJob = false;

      const path = 'JOBS_' + JSON.stringify({
        type: (this.type || this.$route.params.type),
        obj: [this.obj && this.obj.id || 'all']
      })

      const cache = localStorage.getItem(path);


      if (!cache || Number(JSON.parse(cache).expire) < dayjs().unix()) {

        if ((this.type || this.$route.params.type) === 'JOB' || (this.type || this.$route.params.type) === 'MATERIALS') {
          req = this.fire()
            .collection('jobs')
            .where('type', '==', (this.type || this.$route.params.type))
            .where(`objects`, 'array-contains-any', [this.obj && this.obj.id || 'all']);
        } else {
          req = this.fire()
            .collection('jobs')
            .where('type', '==', (this.type || this.$route.params.type));
        }


        let result = [];
        req.get()
          .then((data) => {
            data.forEach((subDoc) => {
              const data = subDoc.data();
              result.push({
                id: subDoc.id,
                ...data,
              });
            });
          })
          .finally(() => {
            if (isCache) {
              localStorage.setItem(path, JSON.stringify({result, expire: dayjs().add(10, 'minute').unix()}))
            }

            const result_filter = (result) => {
              if ((this.type || this.$route.params.type) === 'JOB') {
                return filterJobs(result, this.permission, this.obj && this.obj.id || 'all');
              }

              return result
            }

            this.jobs = _.orderBy(result_filter(result), 'index', ['asc']);
          });
      } else {

        const result = JSON.parse(cache).result
        const result_filter = (result) => {
          if ((this.type || this.$route.params.type) === 'JOB') {
            return filterJobs(result, this.permission, this.obj && this.obj.id || 'all');
          }

          return result
        }

        this.jobs = _.orderBy(result_filter(result), 'index', ['asc']);

        if ((this.type || this.$route.params.type) === 'JOB' || (this.type || this.$route.params.type) === 'MATERIALS') {
          req = this.fire()
            .collection('jobs')
            .where('type', '==', (this.type || this.$route.params.type))
            .where(`objects`, 'array-contains-any', [this.obj && this.obj.id || 'all']);
        } else {
          req = this.fire()
            .collection('jobs')
            .where('type', '==', (this.type || this.$route.params.type));
        }


        let resultr = [];
        req.get()
          .then((data) => {
            data.forEach((subDoc) => {
              const data = subDoc.data();
              resultr.push({
                id: subDoc.id,
                ...data,
              });
            });
          })
          .finally(() => {
            if (isCache) {
              localStorage.setItem(path, JSON.stringify({result: resultr, expire: dayjs().add(10, 'minute').unix()}))
            }

            const result_filter = (result) => {
              if ((this.type || this.$route.params.type) === 'JOB') {
                return filterJobs(result, this.permission, this.obj && this.obj.id || 'all');
              }

              return result
            }

            this.jobs = _.orderBy(result_filter(result), 'index', ['asc']);
          });
      }
    },
    save() {
      if (this.$store.state.project.work_type_require && this.$route.params.type === 'JOB') {
        if (this.form.job.inputs && this.form.job.inputs.find(({type}) => type === 'population')) {

          if((!this.profValue.time  && this.profValue.time !== 0) || (!this.profValue.fact  && this.profValue.fact  !== 0)) {
            return this.$notify({
              offset: 60,
              title: 'Отчет по численности обязательный',
              message: 'Заполните отчет по численности',
              type: 'error',
            });
          }
        }
      }



      let total = 0;
      if (this.form.job.unit_value) {
        total = this.total;
      }

      if (this.form.job.unit && this.form.job.unit.label) {
        this.form.job.unit = this.form.job.unit.label;
      }

      this.form.plan = toFixedWithoutZero(((this.type || this.$route.params.type) === 'JOB') ? this.daily_plan : this.getProfTechPlan)

      if (this.form.job && this.form.job.inputs) {
        this.form.job.inputs = this.form.job.inputs.map((input) => {
          delete input.options
          if (input.type === 'date') {
            return {
              ...input,
              value: dayjs(input.value).format()
            }
          }
          return {
            ...input
          }
        })
      }

      this.$emit('add-job', {
        total,
        uid: this.form.uid || uuidv4(),
        is_select: (this.unit_prop && this.unit_prop === this.form.job.unit) || null,
        ...this.form,
        daily_plan: toFloat(this.form.daily_plan),
        is_daily: !!this.$store.state.project.daily_plan,
        value: this.total_p || this.form.value,
      }, this.index, this.editIndex);

      setTimeout(() => {
        this.close();
      }, 10)
    },
    close() {

      // if (this.$store.state.project.work_type_require && this.$route.params.type === 'JOB') {
      //   if (this.form.job.inputs && this.form.job.inputs.find(({type}) => type === 'population')) {
      //
      //     if((!this.profValue.time  && this.profValue.time !== 0) || (!this.profValue.fact  && this.profValue.fact  !== 0)) {
      //       return this.$notify({
      //         offset: 60,
      //         title: 'Отчет по численности обязательный',
      //         message: 'Заполните отчет по численности',
      //         type: 'error',
      //       });
      //     }
      //   }
      // }

      this.editIndex = null;
      this.isEdit = false;
      this.dialogObject = false;
      this.zoneLock = false
      this.profValue = {
        plan: '',
        fact: ''
      }

      this.techValue = {
        plan: 0,
        fact: 0
      }
      this.$emit('close', {
        isPopulation: this.form.job.inputs && !!this.form.job.inputs.find(({type}) => type === 'population'),
        isTech: this.form.job.inputs && !!this.form.job.inputs.find(({type}) => type === 'tech'),
        uid: this.form.uid
      })
      this.clear();
    },
    clear() {
      this.form = {
        value: '',
        time: '',
        job: null,
        work_type: {},
        daily_plan: '',
        comment: '',
      }
      this.savedJob = {}
      this.step = 0;
      this.isCreateCustom = false;
    },
  },
};
</script>

<style lang="scss">
.add-jobs {
  display: flex;
  flex-direction: column;


  .el-form-item {
    margin-bottom: 0px !important;
  }

  .jobs-ul {
    display: flex;
    flex-direction: column;
    width: 100%;
    margin-top: 8px;
  }

  .jobs-li {
    width: 100%;
    justify-content: flex-start;
    box-sizing: border-box;
    min-height: 36px;
    padding: 8px 10px;
    display: flex;
    text-align: left;
    align-items: center;
    cursor: pointer;
    border-bottom: 1px solid rgba(0, 0, 0, 0.18);

    &:hover {
      background: #eee;
    }

    &:last-child {
      border-bottom: none;
    }
  }

  .select-value {
    display: flex;
    justify-content: space-between;
    flex-direction: column;
    align-items: flex-start;
    text-align: left;

    .input-with-select {
      margin-top: 12px;
    }

    > > > {
      .el-select .el-input {
        width: 142px;
      }
    }
  }
}

.jobs-create-container {
  margin-top: -46px !important;
}

.sum-icon {
  font-weight: bold;
  font-size: 12px;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 18px;
  height: 18px;
  color: #fff;
  background: black;
  cursor: pointer;
  border-radius: 50%;
}

.disable-report {
  opacity: 0.6;
  pointer-events: none;
}


.material-title {
  margin-top: 4px;
  display: flex;
  align-items: center;
}

.form_job_plan {
  display: flex;
  flex-wrap: wrap;
}
</style>



// WEBPACK FOOTER //
// src/views/Dashboard/Reports/components/AddJobs.vue